import React from 'react'
import { Flex } from '@sendoutcards/quantum-design-ui'

export type horizontalInset =
  | 'x1'
  | 'x1_5'
  | 'x2'
  | 'x2_5'
  | 'x3'
  | 'x4'
  | 'x5'
  | 'x6'
  | 'x7'
  | 'x8'

export type verticalInset =
  | 'x0'
  | 'x1'
  | 'x1_5'
  | 'x2'
  | 'x3'
  | 'x4'
  | 'x5'
  | 'x6'
  | 'x7'
  | 'x8'

type SectionProps = {
  children: React.ReactNode
  maxWidth?: string
  horizontalInset?: horizontalInset
  verticalInset?: verticalInset
  backgroundColor?: string
  align?: 'start' | 'center'
}

export const Section: React.FC<SectionProps> = ({
  children,
  maxWidth = '1200px',
  horizontalInset = 'x4',
  verticalInset = 'x4',
  backgroundColor,
  align = 'center',
}) => {
  return (
    <Flex
      width="100%"
      justifyContent="center"
      alignItems="center"
      backgroundColor={backgroundColor}
      inset={{ vertical: verticalInset }}
    >
      <Flex
        width="100%"
        maxWidth={maxWidth}
        inset={{ horizontal: horizontalInset }}
        flexDirection="column"
        justifyContent="center"
        alignItems={align}
      >
        {children}
      </Flex>
    </Flex>
  )
}
